import { Typography } from "@mui/material";
import MuiReverse from "components/MuiExtras/Typography/MuiReverse";
import * as React from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

type PublicationFlags = {
    inPriorityView: boolean;
    inHighlightPeriod: boolean;
};

const FlagsLine: React.FC<{ flags: PublicationFlags; }> = ({ flags }) => {
    const { t } = useTranslation();

    var arr = [];

    if (flags.inPriorityView)
        arr.push(
            <MuiReverse color="warning" flat key="InPriorityViewText">
                <Typography variant="button" style={{ fontSize: "inherit" }}>&nbsp;{t("Common.Feed.Literals.InPriorityViewText")}&nbsp;</Typography>
            </MuiReverse>
        );
    else if (flags.inHighlightPeriod)
        arr.push(
            <MuiReverse color="warning" flat key="InHighlightText">
                <Typography variant="button" style={{ fontSize: "inherit" }}>&nbsp;{t("Common.Feed.Literals.InHighlightText")}&nbsp;</Typography>
            </MuiReverse>
        );

    return <>{arr}</>;
};

export default FlagsLine;